import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberInvoicesComponent } from './member-invoices.component';
import { MemberInvoiceDetailsComponent } from './member-invoice-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiClient } from '../../core/api-client.service';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { MemberNonInvoicePaymentDetailsComponent } from './member-non-invoice-payment-details.component';



@NgModule({
  declarations: [
    MemberInvoicesComponent,
    MemberInvoiceDetailsComponent,
    MemberNonInvoicePaymentDetailsComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule
    , RouterModule
    , NgbPaginationModule
    , NgxMaskDirective
    , NgxMaskPipe
  ],
  providers: [ApiClient],
})
export class MemberInvoicesModule { }
